import { getValueByKey } from '@common/utils/component';
import { RootState } from '../store';

export const dimensionSelector = (state: RootState) => state.pageInfo.dimension;

/**
 * Whether the KeyboardAvoidingViews wrapping screen content may apply their
 * bottom offset. False while an in-app browser is presented over the app, and
 * until this app owns the keyboard state again afterwards.
 */
export const keyboardAvoidingEnabledSelector = (state: RootState) =>
  !state.pageInfo.externalBrowser.isOpen &&
  !state.pageInfo.externalBrowser.isAwaitingKeyboardResync;
export const pagesSelector = (state: RootState) => {
  const pages = state.pageInfo.pages;
  return pages;
};

export const googleMaploaded = (state: RootState) =>
  state.pageInfo.googleMaploaded;

export const valueBindingPageSelector = (state: RootState) =>
  state.pageInfo.valueBindingScreen;

export const simpleBindingSelector =
  (componentId: string) => (state: RootState) =>
    getValueByKey(valueBindingPageSelector(state), componentId);

export const loadingPageSelector = (state: RootState) =>
  state.pageInfo.loadingPage;

export const showQrCodeSelector = (state: RootState) =>
  state.pageInfo.qrCodeScanner;
export const showQrCodeStatusSelector = (state: RootState) =>
  state.pageInfo.qrCodeScanner.status;
export const showQrCodeValueSelector = (state: RootState) =>
  state.pageInfo.qrCodeScanner.qrCode;

export const bindingLoadingSelector = (state: RootState) =>
  state.pageInfo.bindingLoading;

export const pullToRefreshSelector = (state: RootState) =>
  state.pageInfo.pullToRefresh;
